<template><div :class="props.errors.is ? 'cabin__errors cabin-errors' : 'cabin__checked cabin-checked'">
    <template v-if="props.errors.is">
        <div class="cabin-error">
            <div class="cabin-error__icon">
                <vWarning class="icon vicon-orange"/>
            </div>
            <div class="cabin-error__text">{{props.errors.texts.join('; ')}}</div>
        </div>
    </template>
    <template v-else>
        <div class="cabin-checked__icon">
            <component :is="checked()" class="icon" />
        </div>
        <div class="cabin-checked__text">Заполнено верно</div>
    </template>
</div></template>

<script setup>
import vWarning from '@/assets/vicons/seal-warning.vue'
import vCheckes from '@/assets/vicons/checks.vue'
import vDoubleCheckes from '@/assets/vicons/double-check.vue'


const props = defineProps({
    errors: Object, 
    double: {type: Boolean, default: false}
})

const checked = () => {
    return props.double ? vDoubleCheckes : vCheckes
}

</script>
